import type { SetStateAction, Dispatch } from 'react';
import { useState, useEffect } from 'react';

interface UseProgressLoading {
	(initialState?: boolean): [boolean, Dispatch<SetStateAction<boolean>>];
}

export const useProgressLoading: UseProgressLoading = (initialState = true) => {
	const [progressLoading, setProgressLoading] = useState(initialState);

	useEffect(() => {
		if (progressLoading) {
			// not essential data, used "*" as a targetOrigin
			window.postMessage(
				{
					eventType: 'start_progress_bar',
					startDuration: 2000,
					delayDuration: 10000,
				},
				'*',
			);
		} else {
			// not essential data, used "*" as a targetOrigin
			window.postMessage(
				{
					eventType: 'finish_progress_bar',
				},
				'*',
			);
		}
	}, [progressLoading]);

	return [progressLoading, setProgressLoading];
};
